"use client";

import React from "react";
import PropTypes from "prop-types";
import Button from "../../../components/Button";
import styles from "./css/paymentCompleteModal.module.css";

export default function ConfirmPaymentModal({ total, amountPaid, onConfirm, onCancel }) {
  const safeTotal = typeof total === "number" ? total : 0;
  const safeAmount = typeof amountPaid === "number" ? amountPaid : safeTotal;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.confirmPanel}>
        <div className={styles.confirmTitle}>Please confirm that you want to finalize this payment</div>

        <div className={styles.confirmAmountBox}>
          <span className={styles.confirmAmountValue}>R {safeAmount.toFixed(2)}</span>
        </div>

        <div className={styles.confirmActions}>
          <Button
            type="button"
            variant="cancel"
            className={styles.confirmCancelButton}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="approve"
            className={styles.confirmProceedButton}
            onClick={onConfirm}
          >
            Proceed
          </Button>
        </div>
      </div>
    </div>
  );
}

ConfirmPaymentModal.propTypes = {
  total: PropTypes.number,
  amountPaid: PropTypes.number,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
